import { Modal, Table } from 'antd';
import { ColumnsType, TableProps } from 'antd/lib/table';
import React, { ReactElement } from 'react';
import ILoanEmailRecipient from '~Api/LoanEmail/ILoanEmailRecipient';
import RecipientTypeEnum from '~Api/LoanEmail/RecipientTypeEnum';
import './emails.less';
import recipientTypeLabels from './recipientTypeLabels';

export default function RecipientsModal(props: {
    isOpen: boolean;
    onCancel: () => void;
    recipients: ILoanEmailRecipient[];
    recipientType: RecipientTypeEnum;
}): ReactElement {
    const { isOpen, onCancel, recipients, recipientType } = props;

    const columns: ColumnsType<ILoanEmailRecipient> = [
        {
            dataIndex: 'name',
            key: 'name',
            title: 'Name',
        },
        {
            dataIndex: 'email',
            key: 'email',
            title: 'Email',
        },
    ];
    const scroll: TableProps<ILoanEmailRecipient>['scroll'] = { y: 400 };

    return (
        <Modal
            className='loan-emails-recipients-modal'
            footer={false}
            onCancel={onCancel}
            open={isOpen}
            title={recipientTypeLabels[recipientType]}
            width={760}
        >
            <Table
                columns={columns}
                dataSource={recipients}
                pagination={false}
                rowKey='email'
                scroll={scroll}
                size='small'
            />
        </Modal>
    );
}
